'use client';

import { useTheme } from '@/providers/theme-provider';
import CheckBox, { CheckBoxProps } from '@/ui/CheckBox/CheckBox';
import { Moon, SunDim } from 'lucide-react';

export default function ThemeSwitcher(props: CheckBoxProps) {
  const { theme, setTheme, pending } = useTheme();

  return (
    <CheckBox
      checked={theme === 'dark'}
      onChange={(checked) => setTheme(checked ? 'dark' : 'light')}
      uncheckedIcon={<SunDim size={22} />}
      checkedIcon={<Moon size={18} />}
      disabled={pending}
      data-umami-event="switch-theme"
      data-umami-event-theme={theme}
      {...props}
    />
  );
}
